import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";

function ProductListingPublish(props) {

  const [status, setStatus] = useState({
    product: false,
    images: false,
    pricing: false,
    final: "Pending"
  });

  useEffect(() => {

    // Simulate API process

    setTimeout(() => {
      setStatus((prev) => ({ ...prev, product: true }));
    }, 1000);

    setTimeout(() => {
      setStatus((prev) => ({ ...prev, images: true }));
    }, 2000);

    setTimeout(() => {
      setStatus((prev) => ({ ...prev, pricing: true }));
    }, 3000);

    setTimeout(() => {
      setStatus((prev) => ({ ...prev, final: "Processing on Amazon" }));
    }, 4000);

  }, []);

  return (

    <Container>

      <Row>

        {/* Page Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 10 : Publishing Status</h4>
        </Col>


        {/* Publish Status Card */}

        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={12}>
                <h5>Publishing Product Listing</h5>
              </Col>
            </Row>


            <Row className="mb-2">
              <Col md={8}>Product Data Sent</Col>
              <Col md={4} className="text-right">
                {status.product ? "✔" : "⏳"}
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={8}>Images Uploaded</Col>
              <Col md={4} className="text-right">
                {status.images ? "✔" : "⏳"}
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={8}>Pricing Submitted</Col>
              <Col md={4} className="text-right">
                {status.pricing ? "✔" : "⏳"}
              </Col>
            </Row>


            <Row className="mt-4">
              <Col md={12}>
                <b>Status</b>
              </Col>
              <Col md={12} className="mt-2">
                <div className="alert alert-info mb-0">
                  {status.final}
                </div>
              </Col>
            </Row>

          </Card>

        </Col>


        {/* Back Button */}

        <Col md={12} className="mt-3">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingPublish;